import React, {Component} from 'react'
import {Alert, Icon, Input} from 'antd'
import print from '../../../helpers/print'
import OrderLabelDetail from './OrderLabelDetail'
import {getAbleToParseLabel} from "../../../services/api/labelApi"

class OrderLabelPage extends Component {
    state = {
        label: {},
        current: '',
        loading: false,
        error: '',
    }

    _input = React.createRef()

    _handleChange = e => {
        const {value} = e.target

        this.setState({
            current: value,
        })
    }

    _handlePressEnter = () => {
        const check = /^#\d+_\d+$/.test(this.state.current)
        if(!check) {
            return this.setState({
                error: 'Item không đúng định dạng.',
                label: {}
            })
        }
        this._input.current.blur()

        this._fetchLabel(this.state.current)
    }

    _fetchLabel = async (id) => {
        try {
            if (!id.trim()) {
                return
            }

            this.setState({
                loading: true,
                error: '',
            })

            const barcode = id.trim().replace(/^#/, '')

            const {data: response} = await getAbleToParseLabel(barcode)

            const {data, success, error} = response

            if (!success) {
                throw new Error(error)
            }

            this.setState({
                label: data,
                loading: false,
                error: '',
            })

            const {printable_url} = data
            if (!printable_url) return false

            print(printable_url)
        } catch (e) {
            this.setState({
                error: e.message,
                loading: false,
                template: {},
            })
        }
    }

    _clearInput = () => {
        this.setState({
            current: '',
            label: {},
        }, () => {
            this._input.current.focus()
        })
    }

    render() {
        const {label, current, error} = this.state

        return (
            <div className='OrderLabelPage py-3'>
                <div className='bg-light p-3 mb-3'>
                    <h1>Nhập mã đơn</h1>

                    <div className='InputSearch'>
                        <Input size='large' value={current} onChange={this._handleChange}
                               onPressEnter={this._handlePressEnter} ref={this._input} autoFocus/>

                        <div className='position-absolute IconClear'>
                            <Icon type="close-circle" theme="filled" onClick={this._clearInput}/>
                        </div>
                    </div>
                </div>

                {
                    error &&
                    <Alert message='ERROR:' description={error} type='error' showIcon/>
                }

                {
                    label.hasOwnProperty('_id') &&
                    <OrderLabelDetail label={label} onClearInput={this._clearInput}/>
                }
            </div>
        )
    }
}

export default OrderLabelPage
